// (string) short date format
export const DATE_FORMAT_IN_NUMBERS = "YYYY/MM/DD";
export const DATE_FORMAT_IN_LETTERS = "D MMMM ، YYYY";
export const DATE_FORMAT_EMPTY_STATE = "--/--/----";

export const DAY_OF_WEEK = "ddd"
export const DAY_OF_WEEK_EMPTY_STATE = "---"

// (string) short time format
export const SHORT_TIME_FORMAT = "HH:mm";